import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, LIST_ALL_MERCHANTS ,ELASTIC_SEARCH_BASE_URL,LIST_ALL_MERCHANTSLOC} from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
const initialState = {
  loading: false,
  MerchantListData: [],
  MerchantListDataloc: [],
  successMessage: "",
  error: "",
};

export const fetchMerchantsList = createAsyncThunk(
  "ExportInventory/fetchMerchantsList.",
  async (data , { rejectWithValue }) => {
    const { token, ...dataAlter } = data;
    try {
      const response = await axios.post(
        BASE_URL + LIST_ALL_MERCHANTS,
        dataAlter,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === true) {
        // console.log(response);
        return response.data.result;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);



export const fetchMerchantsListloc = createAsyncThunk(
  "ExportInventory/fetchMerchantsListloc.",
  async (data , { rejectWithValue }) => {
    const { token, ...dataAlter } = data;
    try {
      const response = await axios.post(
        ELASTIC_SEARCH_BASE_URL + LIST_ALL_MERCHANTSLOC,
        dataAlter,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === true) {
        // console.log(response);
        return response.data.result;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const ExportInventorySlice = createSlice({
  name: "ExportInventory",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMerchantsList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMerchantsList.fulfilled, (state, action) => {
      state.loading = false;
      state.MerchantListData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchMerchantsList.rejected, (state, action) => {
      state.loading = false;
      state.MerchantListData = {};
      state.error = action.error.message;
    });


    builder.addCase(fetchMerchantsListloc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMerchantsListloc.fulfilled, (state, action) => {
      state.loading = false;
      state.MerchantListDataloc = action.payload;
      state.error = "";
    });
    builder.addCase(fetchMerchantsListloc.rejected, (state, action) => {
      state.loading = false;
      state.MerchantListDataloc = {};
      state.error = action.error.message;
    });
  },
});

export default ExportInventorySlice.reducer;
